export class ReorderInspectionTemplateError extends Error {
  constructor(
    message: string = 'Failed to reorder inspection template',
    options?: ErrorOptions
  ) {
    super(message, options);
    this.name = 'ReorderInspectionTemplateError';
  }
}
